class LinstanReferencesSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    
    this.input = this.element.querySelector("input");
    this.resultsWrapper = this.element.querySelector("[data-linstan-references-results]");
    this.refNotFound = this.element.querySelector("[data-linstan-references-not-found]");

    if (window.hasOwnProperty('linstanReferencesData')) {
      this.linstanReferencesData = window.linstanReferencesData.data;
      this.referencesArray = [];

      this.createResultsList();

      if (document.querySelector(".pk-linstan-references-search__item")) {
        this.resultsList = document.querySelectorAll(".pk-linstan-references-search__item");
        
        this.onInputValueChange();
      }
    } else {
      this.resultsWrapper.innerHTML = "Un problème est survenu avec la récupération des références..."
    }
  }

  onInputValueChange() {    
    this.input.addEventListener('input', (e) => {
      const query = this.input.value.toLowerCase().trim();
      
      if (query.length >= 9) {
        this.toggleResults(query);
      } else {
        this.resultsWrapper.setAttribute("aria-expanded", "false");
        this.refNotFound.classList.add("hidden");
        this.hideAllResults();
      }
    });
  }

  toggleResults(query) {
    let isMatching = false;
    
     this.resultsList.forEach(ref => {
      const reference = ref.textContent.toLowerCase();
      const referenceWithSpace = ref.textContent.toLowerCase().replaceAll(".", " ");
      const referenceWithPoint = ref.textContent.toLowerCase().replaceAll(".", "");
       
      if (reference.includes(query) || referenceWithSpace.includes(query) || referenceWithPoint.includes(query)) {
        isMatching = true;
        ref.classList.remove("hidden");
        this.resultsWrapper.setAttribute("aria-expanded", "true");
      } else {
        ref.classList.add("hidden");
        this.refNotFound.classList.add("hidden");
      }
    });

    if (isMatching) {
      this.resultsWrapper.setAttribute("aria-expanded", "true");
      this.refNotFound.classList.add("hidden");
    } else {
      this.resultsWrapper.setAttribute("aria-expanded", "false");
      this.refNotFound.classList.remove("hidden");
    }
  }

  createResultsList() {
    if (this.linstanReferencesData) {
      this.linstanReferencesData.forEach(collection => {
        const collectionReferences = collection.references;
        const url = collection.url;

        collectionReferences.forEach(reference => {
          const ref = reference.toLowerCase().trim();
          const urlWithRef = `${url}#ref${ref}`;
     
          const linkElement = document.createElement("a"); 
          
          linkElement.innerHTML = ref;
          linkElement.setAttribute('href', `${urlWithRef}`);
          linkElement.classList.add("pk-linstan-references-search__item", "hidden");
          
          this.resultsWrapper.append(linkElement);
        });
      });
    }
  }

  hideAllResults() {
    this.input.setAttribute("value", "");
    
    this.resultsList.forEach(item => {
      item.classList.add("hidden");
    });
  }
}

customElements.define('linstan-references-search', LinstanReferencesSearch);
